import { styled } from '@mui/material'

export const ContainerSt = styled('div', {
  shouldForwardProp: (prop) => prop !== 'mapHeight' && prop !== 'mapMaxHeight',
})<{ mapHeight?: string; mapMaxHeight?: string }>(({ theme, mapHeight = '55vh', mapMaxHeight }) => ({
  display: 'flex',
  justifyContent: 'center',
  height: mapHeight,
  textAlign: 'center',
  overflow: 'hidden',
  ...(mapMaxHeight ? { maxHeight: mapMaxHeight } : {}),
  [theme.breakpoints.down('md')]: {
    zIndex: 0,
    left: 0,
    top: 0,
    height: mapHeight,
    ...(mapMaxHeight ? { maxHeight: mapMaxHeight } : {}),
  },
  [theme.breakpoints.up('md')]: {
    position: 'relative',
    height: mapHeight,
    ...(mapMaxHeight ? { maxHeight: mapMaxHeight } : {}),
  },
}))

export const MapWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'mapHeight' && prop !== 'mapMaxHeight',
})<{ mapHeight?: string; mapMaxHeight?: string }>(({ theme, mapHeight = '55vh', mapMaxHeight }) => ({
  width: '100%',
  zIndex: 0,
  height: mapHeight,
  position: 'relative',
  ...(mapMaxHeight ? { maxHeight: mapMaxHeight } : {}),
  [theme.breakpoints.down('md')]: {
    height: mapHeight,
    ...(mapMaxHeight ? { maxHeight: mapMaxHeight } : {}),
  },
  [theme.breakpoints.up('md')]: {
    height: mapHeight,
    ...(mapMaxHeight ? { maxHeight: mapMaxHeight } : {}),
  },
}))

export const OverlayTitleWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: 0,
  bottom: '18px',
  zIndex: 1000,
  padding: "6px 16px",
  pointerEvents: 'none',
  fontSize: '24px',
  maxWidth: '400px',
  textAlign: 'left',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
  [theme.breakpoints.down('md')]: {
    paddingRight: '50px',
  },
}))

export const AccountImageItem = styled('div')({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: 0,
  pointerEvents: 'auto',
})
